import type { SiteConfig } from '@/types'

// Static site identity used for page titles and social previews. Visible content
// (description, contact details, copy) lives in the CMS and is loaded per page.
export const siteConfig: SiteConfig = {
    name: 'Dhurata e Bajramit',
    description: "Një Bajram më ndryshe për fëmijën tuaj, për fëmijët e familjes dhe për ata që nuk kanë mundësi materiale.",
    url: (process.env.NEXT_PUBLIC_SITE_URL || 'https://dhurataebajramit.com').replace(/\/+$/, ''),
    locale: 'sq_AL',
    keywords: ['Dhurata', 'Bajram', 'Fëmijë', 'Eid', 'Kosovo', 'Dhurata e Bajramit'],
    ogImage: '/images/dhurata-banner.png'
}
